import { Map, List, fromJS } from 'immutable';

export function request(state, { marketTemplateId }) {
    let items = state.get('items') || Map();

    items = items.set(
        marketTemplateId,
        items.get(marketTemplateId).set('_state', 'IN_PROGRESS')
    );

    return state.set('items', items);
}

export function error(state, { marketTemplateId, errors }) {
    let items = state.get('items') || Map();

    items = items.set(
        marketTemplateId,
        items.get(marketTemplateId)
            .set('_state', 'ERROR')
            .set('errors', fromJS(errors))
    );

    return state.set('items', items);
}

export function finish(state, { id, marketTemplateId, data }) {
    state = state.setIn([ 'items', marketTemplateId, '_state' ], 'FINISHED');

    let index = state.getIn([ 'items', marketTemplateId, 'selections' ]).findIndex(x => x.get('id') === id);

    if (index !== -1) {
        return state.setIn([ 'items', marketTemplateId, 'selections', index ], fromJS(data));
    }

    return state;
}
